<template>
  <div>
    <v-card class="mb-3 sticky-element" :class="stickyClass">
      <v-layout row wrap justify-space-between >
        <v-flex xs12 sm6 class="pa-2">
          <v-layout row wrap>
            <v-flex shrink class="text-xs-center mr-3">
              <v-avatar size=48 >
                <v-icon color="primary" large>visibility</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex shrink class="grey--text" >
              <h1 class="grey--text text--darken-2">
                Activity
              </h1>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout row wrap mb-4>
      <v-flex>
        <v-expansion-panel v-model="panel">
          <v-expansion-panel-content class="v-expansion-panel-activity">
            <template v-slot:header>
              <v-layout row class="subheading" >
                <v-flex class="white--text">
                  <v-icon color="white" class="pr-3">visibility</v-icon>
                  Recent activity spanning {{watchDuration}}
                </v-flex>
              </v-layout>
            </template>

            <v-card>
              <v-layout justify-end row wrap>
                <v-flex shrink class="mr-3" xs6 md4 lg3>
                  <v-text-field v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    inline-flex
                    ref="watchesSearch"
                    @keyup="searchWatches"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-data-table
                :headers="headers"
                :items="searchedWatches"
                :total-items="searchedWatches.length"
                :loading="loading"
                hide-actions
                no-data-text="Loading recent activity..."
                class="mt-4"
                >
                <template slot="items"
                  slot-scope="props"
                  >
                  <projectRow :watch="props.item" :project="itemForWatch(props.item)" v-if="props.item.relationships.watchable.data.type === 'project'"></projectRow>
                  <boardRow :watch="props.item" :board="itemForWatch(props.item)" v-if="props.item.relationships.watchable.data.type === 'board'"></boardRow>
                  <ticketRow :watch="props.item" :ticket="itemForWatch(props.item)" v-if="props.item.relationships.watchable.data.type === 'ticket'"></ticketRow>
                </template>
                <v-alert slot="no-results"
                  :value="true"
                  color="error"
                  icon="warning"
                  >
                  No recent activity...
                </v-alert>
              </v-data-table>
              <div class="pb-4">
                <!-- Last line to provide padding for the favbuttons -->
              </div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { debounce } from 'debounce'
  import { EventBus } from '@/utilities/event-bus'
  import authentication from '@/utilities/authentication'

  import watchService from '@/services/watch'
  import projectService from '@/services/project'
  import boardService from '@/services/board'
  import ticketService from '@/services/ticket'

  import projectRow from '@/components/watch/_project_row'
  import boardRow from '@/components/watch/_board_row'
  import ticketRow from '@/components/watch/_ticket_row'

  export default {
    name: 'watch-index',

    components: {
      projectRow: projectRow,
      boardRow: boardRow,
      ticketRow: ticketRow
    },

    props: [],

    data () {
      return {
        auth: authentication,
        search: '',
        watches: [],
        projects: [],
        boards: [],
        tickets: [],
        searchedWatches: [],
        loading: true,
        panel: null,
        headers: [
          { text: '', sortable: false },
          { text: 'Name', align: 'left', sortable: false },
          { text: ' ', align: 'left', sortable: false },
          { text: ' ', align: 'left', sortable: false },
          { text: 'Last updated', align: 'left', sortable: false },
          { text: 'Watch', align: 'left', sortable: false }
        ]
      }
    },

    mounted () {
      this.loadUserWatches()

      EventBus.$on('watch-deleted', (payload) => {
        if (payload) {
          this.watches = this.watches.filter(w => parseInt(w.id) !== parseInt(payload.id))
          this.searchWatches()
        }
      })
      this.panel = 0
    },

    computed: {
      stickyClass () {
        if (window.innerWidth > 599) {
          if (this.scroll > 0) {
            return 'elevation-8'
          } else {
            return ''
          }
        }
      },

      watchDuration () {
        let count = parseInt(this.auth.preferences().watch_weeks)
        if (count > 1) {
          return `${count} weeks`
        } else if (isNaN(count)) { // sometimes we find users where this is not configured
          return ''
        } else {
          return `${count} week`
        }
      }
    },

    methods: {
      loadUserWatches () {
        this.loading = true
        watchService.userIndex(
          async (data) => {
            this.watches = data.sort((b, a) => new Date(a.attributes.changed_at).getTime() - new Date(b.attributes.changed_at).getTime())
            let promises = []
            for (let w of data) {
              promises.push(this.loadWatchedItem(w))
            }
            await Promise.all(promises)
            this.searchWatches()
          },
          (err) => {
            console.log(err)
          },
          this.auth.userId(),
          this.auth.preferences().watch_weeks
        )
      },

      loadWatchedItem (watch) {
        let type = watch.relationships.watchable.data.type
        let id = watch.relationships.watchable.data.id
        let promise = null
        switch (type) {
          case 'project': {
            promise = projectService.show(
              (data) => {
                this.projects.push(data)
              },
              (err) => {
                console.log(err)
              },
              id
            )
            break
          }
          case 'board': {
            promise = boardService.show(
              (data) => {
                this.boards.push(data)
              },
              (err) => {
                console.log(err)
              },
              id
            )
            break
          }
          case 'ticket': {
            promise = ticketService.show(
              (data) => {
                this.tickets.push(data)
              },
              (err) => {
                console.log(err)
              },
              id
            )
            break
          }
        }
        return promise
      },

      itemForWatch (watch) {
        let type = watch.relationships.watchable.data.type
        let id = watch.relationships.watchable.data.id
        let item = null
        switch (type) {
          case 'project': {
            item = this.projects.find(pr => parseInt(pr.id) == parseInt(id))
            break
          }
          case 'board': {
            item = this.boards.find(brd => parseInt(brd.id) == parseInt(id))
            break
          }
          case 'ticket': {
            item = this.tickets.find(tck => parseInt(tck.id) == parseInt(id))
            break
          }
        }
        return item
      },

      searchWatches: debounce(function () {
        EventBus.$emit('watch-search', this.search)
        // We need to probably extend this to search for more things, for now a very basic text search will sufffice
        this.$nextTick(() => {
          if (this.search.length > 0) {
            let regex = new RegExp(this.search, 'ig')
            let filteredWatches = this.watches.filter((watch) => {
              let item = this.itemForWatch(watch)
              let hasMatch = false
              hasMatch = hasMatch || (item.attributes.sequential_id && item.attributes.sequential_id.toString().match(regex))
              hasMatch = hasMatch || (item.attributes.name && item.attributes.name.match(regex))
              hasMatch = hasMatch || (item.attributes.title && item.attributes.title.match(regex))
              return hasMatch
            })
            this.searchedWatches = filteredWatches
          } else {
            this.searchedWatches = this.watches
          }
          this.loading = false
        })
      }, 1000)

    }
  }
</script>

<style lang="scss" scoped>
  .project-search {
    border-bottom: 1px solid lightgrey;
  }

  .v-expansion-panel-activity {
    background-color: #0155a8 !important;
  }

  tr:first-child {
    border-top: 1px solid lightgrey;
  }

</style>



// WEBPACK FOOTER //
// src/components/watch/index.vue